// Auto Migration Hook
import { useEffect, useState } from 'react';
import { DatabaseMigrator } from '../utils/databaseMigrations';

export const useDatabaseMigrations = () => {
  const [migrationStatus, setMigrationStatus] = useState<'idle' | 'running' | 'completed' | 'error'>('idle');
  
  useEffect(() => {
    // Migration sistemi geçici olarak devre dışı - Manuel SQL gerekli
    // Detaylar için MANUAL_FIX_REQUIRED.md dosyasına bakın
    setMigrationStatus('completed');
  }, []);
  
  return { migrationStatus };
};